import React from "react";
import DateRangeFilter from "../filterDropdown/DateRangeFilter";
import SearchableMultiSelect from "../controls/SearchableMultiSelect";
import { ExpenseListFilters } from "../../shared/expenseFilters";
import { ExpenseUserOption } from "../../shared/expenseUsersApi";

interface ExpenseFiltersProps {
  filters: ExpenseListFilters;
  isAdmin: boolean;
  userOptions: ExpenseUserOption[];
  userOptionsLoading: boolean;
  onChange: (filters: ExpenseListFilters) => void;
}

export default function ExpenseFilters({
  filters,
  isAdmin,
  userOptions,
  userOptionsLoading,
  onChange,
}: ExpenseFiltersProps) {
  return (
    <>
      <DateRangeFilter
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChange={(name: "startDate" | "endDate", value: Date | null) =>
          onChange({ ...filters, [name]: value })
        }
        resetFilter={() => onChange({ ...filters, startDate: null, endDate: null })}
      />
      {isAdmin && (
        <div className="p-3">
          <SearchableMultiSelect
            inputId="expense-person-filter"
            label="Person"
            options={userOptions}
            value={filters.userIds ?? []}
            disabled={userOptionsLoading}
            showClear
            placeholder={userOptionsLoading ? "Loading users…" : "All people"}
            onChange={(userIds) => onChange({ ...filters, userIds })}
          />
        </div>
      )}
    </>
  );
}
